import * as React from 'react';
import { Header4 } from '@cian/ui-kit/typography';
import { mergeStyles } from '@cian/utils';
import { ICoworkingAmenity, ICoworkingAmenityNames } from '@cian/api-models/offer-card/v1/get-offer-data';

import { CoworkingAmenity } from '../CoworkingAmenity';

const styles = require('./CoworkingAmenitiesGroup.css');

interface ICoworkingAmenitiesGroup {
  title: string;
  availableAmenities: ICoworkingAmenityNames[];
  className?: string;
  includedAmenities?: ICoworkingAmenity[];
}

export function CoworkingAmenitiesGroup({
  title,
  availableAmenities,
  includedAmenities,
  className,
}: ICoworkingAmenitiesGroup) {
  const amenitiesList = React.useMemo(() => includedAmenities?.filter(({ key }) => availableAmenities.includes(key)), [
    availableAmenities,
    includedAmenities,
  ]);

  if (!amenitiesList?.length) {
    return null;
  }

  return (
    <div {...mergeStyles(styles['root'], className)}>
      <Header4>{title}</Header4>
      <div className={styles['amenity-list']}>
        {amenitiesList.map(({ title, key }) => (
          <CoworkingAmenity title={title} key={key} keyName={key} className={styles['amenity']} />
        ))}
      </div>
    </div>
  );
}
